




































import { Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { MessageType, MessagePostRequest } from '@/api/message/types'
import { ValidationErrorResponse } from '@/api/types'
import ky from 'ky'
import Form from '@/mixins/form'
import { mixins } from 'vue-class-component'
import WebSocketProvider from '@/websocket'
import { WebSocketMessageMode } from '@/websocket/constants'
import { WebSocketMessageMessageTypes } from '@/websocket/receivers/message'
import { ReceiveMessageBodyMessageMessage } from '@/websocket/receivers/message/receiveMessages'

@Component({
  components: {
    WorkerList: () =>
      import('@/components/patient/MessageWorkerRelativeList.vue'),
    MessageHistory: () => import('@/components/patient/MessageHistory.vue'),
    UserIcon: () => import('@/components/common/UserIcon.vue'),
    Loading: () => import('@/components/common/loadings/Index.vue'),
    TextareaInput: () => import('@/components/common/inputs/TextareaInput.vue')
  }
})
export default class Call extends mixins(Form) {
  $store!: ExStore
  messageTypes: MessageType[] = []
  selectedType = 1 //TODO: 現在全てのメッセージが「確認」となる
  content = ''
  error: ValidationErrorResponse = {}
  historyKey = 'history'
  webSocket = WebSocketProvider.createConnection()

  async beforeCreate() {
    this.messageTypes = await this.$api.message.types()

    this.webSocket.subscribeMessage(
      WebSocketMessageMode.MESSAGE,
      WebSocketMessageMessageTypes.MESSAGE,
      this.handleReceiveMessage.bind(this)
    )
  }

  get recipients() {
    return this.$store.getters['message/recipients']
  }

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  get messageData(): MessagePostRequest | null {
    const type = this.messageTypes.find(type => type.level == this.selectedType)
    const recipients = this.recipients.map(recipient => ({
      user: recipient.id
    }))
    if (!type || !recipients.length) return null
    return {
      user: this.userInfo.id,
      messageTypeLevel: type.level,
      messageTypeName: type.name,
      content: this.content,
      messageuserSet: recipients
    }
  }

  created() {
    this.$postMessage.addEventListener('activateApp', () => {
      this.webSocket = WebSocketProvider.createConnection()
    })
  }

  handleReceiveMessage() {
    this.reloadHistory()
  }

  async handleSend() {
    if (!this.validation()) return
    const data = this.messageData
    if (!data) return
    try {
      this.webSocket.send(WebSocketMessageMode.MESSAGE, {
        type: WebSocketMessageMessageTypes.MESSAGE,
        to: data.messageuserSet.map(({ user }) => user),
        message: data
      })
      this.resetMessageForm()
    } catch (e) {
      if (e instanceof ky.HTTPError) {
        const errors = await e.response.json()
        this.error = errors
        return
      }
      console.error(e)
    }
  }

  resetMessageForm() {
    this.$store.dispatch('message/updateRecipients', [])
    this.content = ''
  }

  reloadHistory() {
    this.$store.dispatch('message/updateHistory')
    this.historyKey = `history-${Date.now()}`
  }

  validation() {
    let valid = true
    this.error = {}
    if (!this.recipients.length) {
      this.error['recipients'] = ['宛先が選択されていません。']
      valid = false
    }
    if (this.validator.hasAnyError()) {
      this.error['content'] = [this.validator.getErrorMessage('content')]
      valid = false
    }
    return valid
  }
}
